/**
 banner data store
 */

import { mapGetters } from 'vuex'

export const banner = {
    namespaced: true,
    state: {
        bannerItem:[],
        testVar1:"am test var 1",
        testVar2:"am test var 2",
    },
    mutations: {
        setBanner(state, payload) {
            state.bannerItem= payload
        }
    },
    getters: {
        testGetter1: state => {
            return `from getter:${state.testVar1}`;
        },
        testGetter2: state => {
            return `from getter:${state.testVar2}`;
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/banner.js